module.exports = __webpack_public_path__ + "img/loveInvitation.ba773299.jpg";